<template>
  <div class="paySys-body" id="paySystemActivity">
    <div class="paysys-box">
      <div class="paysys-all">
        <div class='sys-back-button' @click="backHistory()">
          <img src="../../assets/images/paySystem/icon_arrow_left.png">
          {{$t('language.cloudExploer.back')}}
        </div>
        <div class="christmas-title-img">
          <img style="margin-top: 23Px;" src="../../assets/images/christmasSaled-2022/icon_christmas_tree.png">
          <img :src="getTitleImg()">
        </div>
        <div class="paysys-title">
          <span>{{$t('language.christmas.pageTitle2',{'num':num})}}</span>
        </div>
        <div class="paysys-countdown">
          <img :src="require('../../assets/images/christmasSaled-2022/img_countdown_'+lang+'.png')">
        </div>
        <div class="paySwitch" v-if="!user.vip||(user.vip&&user.payLevel>1)">
          <div class="switch-all">
            <div class="switch-left" :class="clickIndex==0?'switch-click':''" @click="changeChoosePlan(0)" :style="$i18n.locale=='italian'?'min-width:180px;':''">
              <span>{{$t('language.paySystem.limitedData')}}</span>
            </div>
            <div class="seitch-right" :class="clickIndex==1?'switch-click':''" @click="changeChoosePlan(1)" :style="$i18n.locale=='italian'?'min-width:180px;':''">
              <span>{{$t('language.paySystem.unlimitedData')}}</span>
            </div>
          </div>
        </div>

        <div ref="allBottom" class="paySys-bottom" :class="user.vip&&user.payLevel<=1?'paySys-bottom-unlimit':''" style="margin-bottom:5px;">
          <div class="paysys-div-all">
            <paySchemeTab ref="payScheme" v-if="!user.vip"></paySchemeTab>
            <paySchemeTab ref="payScheme" v-if="user.vip&&nowScheme&&clickIndex==1" :payScheme=nowScheme :index=-1></paySchemeTab>
            <paySchemeTab ref="payScheme" v-for="(allowScheme,index) in allowSchemes" :key="index" :payScheme=allowScheme :index=index :style="allowScheme.type=='Lifetime'?'border: 2px solid #CE170D;':''"></paySchemeTab>
          </div>
        </div>
        <div class="tips-txt">
          <div class="pay-tips" v-html="$t('language.paySystem.tips2')" >
          </div>
        </div>
      </div>
  </div>
    <bindEmailDialog ref="bindEmailDialog"></bindEmailDialog>
    <payDiffDialog ref="payDiffDialog"></payDiffDialog>
    <payErrorNoticeDialog ref="payErrorNoticeDialog"></payErrorNoticeDialog>
    <bindEmailJumpDialog ref="bindEmailJumpDialog"></bindEmailJumpDialog>
    <nowPaySchemeDialog ref="nowPaySchemeDialog"></nowPaySchemeDialog>
    <iosPayTipDialog ref="iosPayTipDialog"></iosPayTipDialog>
    <appNowPaySchemeDialog ref="appNowPaySchemeDialog"></appNowPaySchemeDialog>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
import paySchemeTab from '@/components/common/tabs/tabs_pay_system/tab_pay_scheme_active';
import googleAnalyticsUtil from "../../js/workspace/google_analytics_util.js";
import bindEmailDialog from '@/components/popup/pay_system_popups/bind_email_topay_popup';
import payDiffDialog from '@/components/popup/pay_system_popups/pay_diff_money_popup';
import payErrorNoticeDialog from '@/components/popup/pay_system_popups/pay_error_notice_popup';
import bindEmailJumpDialog from '@/components/popup/personal_center_popups/bind_email_popup';
import paySysUtils from "@/js/workspace/pay_system_util.js";
import nowPaySchemeDialog from '@/components/popup/pay_system_popups/now_pay_scheme_popups';//用户当前套餐信息弹窗
import getCurrencyUtils from '@/js/workspace/get_currency.js';
import iosPayTipDialog from '@/components/popup/pay_system_popups/ios_pay_tip_popups';//用户当前套餐信息弹窗
import appNowPaySchemeDialog from '@/components/popup/pay_system_popups/app_now_pay_scheme_popups';//用户当前套餐信息弹窗
export default {
  data () {
    return {
      newPayMoney:'',
      sendSubScribeRequest: true,//是否能向CB发送请求，true表示可以，false，表示不能向cb发送消息
      user: commonUtils.getUser(),
      clickIndex: 1,
      usedTraffic: '',
      flow: '', //显示有限月定的流量包
      subscriptionTtem: {}, //存储用户当前订阅的项目
      nowData: [],
      requestNum: 0, //请求后端代码的次数
      checkCycleType: 0,//选中的付费周期类型0：月，1：年
      nowScheme: null,
      allSchemes: [],//全部可选套餐
      allowSchemes: [],//当前页面展示套餐
      limitedOtherPlan: [
        {
          "id" : "aec30c2a79b348d794775aebaf111bde",
          "name" : "50GB",
          "cartId" : "214087",
          "coupon" : "",
          "attrib" : 3,
          "type" : "",
          "level" : 3,
          "payMony" : {
            "TWD" : "NT$ 171",
            "JPY" : "707 円",
            "ECU" : "5,99 €",
            "USD" : "$ 5.99",
            "BRL" : "R$ 31",
            "CNY" : "¥ 38"
          },
          "flow" : 53687091200,
          "parameters" : {
            "xPage" : "2023-new-year-traffic-50gb",
            "xLevel" : 3,
            "xGurantee" : 14,
            "xMb" : 14
          },
          "arguments" : {
            "title" : "package50GB"
          },
          "isEnable" : 1,
          "isDifferencePrice" : 0
        }, {
          "id" : "6824d86bd1e34412be78f6369a7f2d2d",
          "name" : "100GB",
          "cartId" : "240895",
          "coupon" : "J3Q-EBB-YVN",
          "attrib" : 3,
          "type" : "",
          "level" : 3,
          "payMony" : {
            "TWD" : "NT$ 285",
            "JPY" : "1,179 円",
            "ECU" : "9,99 €",
            "USD" : "$ 9.99",
            "BRL" : "R$ 52",
            "CNY" : "¥ 63"
          },
          "oldPayMony" : {
            "TWD" : "NT$ 342",
            "JPY" : "1,414 円",
            "ECU" : "11,98 €",
            "USD" : "$ 11.98",
            "BRL" : "R$ 62",
            "CNY" : "¥ 76"
          },
          "flow" : 107374182400,
          "parameters" : {
            "xPage" : "2023-new-year-traffic-100gb",
            "xLevel" : 3,
            "xGurantee" : 14,
            "xMb" : 14
          },
          "arguments" : {
            "cuppon" : 17,
            "title" : "package100GB"
          },
          "isEnable" : 1,
          "isDifferencePrice" : 0
        },
      ],
      num: 71,//默认折扣71
      lang: commonUtils.getLocaleToIndex(localStorage.getItem("locale")),
      dataJson: [{
        paySysName: this.$t('language.paySystem.threeMonth'),
        payMony: this.$t('language.popup.upgradeAccountPopup.free'),
        property: '',
        includes: [{
          name: this.$t('language.popup.upgradeAccountPopup.monthTraffic'),
          des: this.$t('language.popup.upgradeAccountPopup.freeDes')
        },
        {
          name: this.$t('language.popup.upgradeAccountPopup.syncMode')
        },
        {
          name: this.$t('language.popup.upgradeAccountPopup.offlineFree')
        },
         {
          name: this.$t('language.cloudSync.realSync')
        },
        {
          name: this.$t('language.popup.upgradeAccountPopup.scheduled'),
        }
        ],
        summary: ''
      }, {
        paySysName: this.$t('language.paySystem.limitedMonth'),
        payMony: '$9.9',
        flow: '150' + this.$t('language.paySystem.gb'),
        payType: 'Monthly',
        payLevel: 2,
        property: this.$t('language.paySystem.monthlyPayment'),
        productId: '214430',
        xMb: 14, //退款天数
        xPage: 'monthly2',
        includes: [{
          name: this.$t('language.paySystem.limitedTrafficMonth'),
          des: ''
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.moreSyncModes'),
          des: this.$t('language.popup.upgradeAccountPopup.syncSupported')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.offlinePremium')
        }, 
         {
          name: this.$t('language.cloudSync.realSync')
        },
        {
          name: this.$t('language.popup.upgradeAccountPopup.scheduled')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferSpeed'),
          des: this.$t('language.popup.upgradeAccountPopup.greatlyIncreased')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.doubleSync'),
          des: this.$t('language.popup.upgradeAccountPopup.sameTime')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.filter'),
          des: this.$t('language.popup.upgradeAccountPopup.automatically')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferServer'),
          des: ''
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.customerSupport'),
          des: ''
        }],
        summary: {
          sname: this.$t('language.paySystem.billed'),
          sDes: this.$t('language.paySystem.subCould')
        }
      },
      {
        paySysName: this.$t('language.paySystem.YearlyUnlimited'),
        payMony: '$119.9',
        payType: 'Yearly',
        payLevel: 1,
        productId: "214433",
        xMb: 30, //退款天数
        xPage: 'yearly-un3',
        property: this.$t('language.paySystem.YearlyPaymentNine'),
        includes: [{
          name: this.$t('language.paySystem.foraYear')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.moreSyncModes'),
          des: this.$t('language.popup.upgradeAccountPopup.syncSupported')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.offlinePremium')
        },
         {
          name: this.$t('language.cloudSync.realSync')
        },
         {
          name: this.$t('language.popup.upgradeAccountPopup.scheduled')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferSpeed'),
          des: this.$t('language.popup.upgradeAccountPopup.greatlyIncreased')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.doubleSync'),
          des: this.$t('language.popup.upgradeAccountPopup.sameTime')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.filter'),
          des: this.$t('language.popup.upgradeAccountPopup.automatically')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferServer')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.customerSupport')
        }],
        summary: {
          sname: this.$t('language.paySystem.noNeedPurchase')
        }
      },
      {
        paySysName: this.$t('language.rightTopBanner.lifeTimePlan'),
        payMony: '$239.4',
        payType: 'Lifetime',
        productId: '226093',
        xMb: 30, //退款天数
        xPage: 'life-un3',
        coupon: 'F3A-ZRG-133',
        payLevel: 1,
        specialOffer: true,
        oldPayMony: '$399.0',
        property: this.$t('language.paySystem.Onetime'),
        includes: [{
          name: this.$t('language.paySystem.unlimitedTraffic')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.moreSyncModes'),
          des: this.$t('language.popup.upgradeAccountPopup.syncSupported')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.offlinePremium')
        },  {
          name: this.$t('language.cloudSync.realSync')
        },
        {
          name: this.$t('language.popup.upgradeAccountPopup.scheduled')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferSpeed'),
          des: this.$t('language.popup.upgradeAccountPopup.greatlyIncreased')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.doubleSync'),
          des: this.$t('language.popup.upgradeAccountPopup.sameTime')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.filter'),
          des: this.$t('language.popup.upgradeAccountPopup.automatically')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferServer')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.customerSupport')
        }],
        summary: {
          sname: this.$t('language.paySystem.noNeedPurchase')
        }
      },
      ],
      monthlyUnlimited: {
        paySysName: this.$t('language.paySystem.monthlyUnlimited'),
        payMony: '$19.9',
        payType: 'Monthly',
        payLevel: 1,
        property: this.$t('language.paySystem.monthlyPayment'),
        includes: [{
          name: this.$t('language.paySystem.monthTraffic')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.moreSyncModes'),
          des: this.$t('language.popup.upgradeAccountPopup.syncSupported')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.offlinePremium')
        },  {
          name: this.$t('language.cloudSync.realSync')
        },
        {
          name: this.$t('language.popup.upgradeAccountPopup.scheduled')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferSpeed'),
          des: this.$t('language.popup.upgradeAccountPopup.greatlyIncreased')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.doubleSync'),
          des: this.$t('language.popup.upgradeAccountPopup.sameTime')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.filter'),
          des: this.$t('language.popup.upgradeAccountPopup.automatically')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferServer')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.customerSupport')
        }],
        summary: {
          sname: this.$t('language.paySystem.noNeedPurchase')
        }
      },
      freeOtherPlan: [{
        paySysName: this.$t('language.paySystem.threeMonth'),
        payMony: this.$t('language.popup.upgradeAccountPopup.free'),
        property: '',
        includes: [{
          name: this.$t('language.popup.upgradeAccountPopup.monthTraffic'),
          des: this.$t('language.popup.upgradeAccountPopup.freeDes')
        },  {
          name: this.$t('language.popup.upgradeAccountPopup.syncMode')
        },
        {
          name: this.$t('language.popup.upgradeAccountPopup.offlineFree')
        }, {
          name: this.$t('language.cloudSync.realSync')
        },
         {
          name: this.$t('language.popup.upgradeAccountPopup.scheduled')
        },],
        summary: ''
      }, {
        paySysName: this.$t('language.paySystem.twoMonthree'),
        flow: '200' + this.$t('language.paySystem.gb'),
        payMony: '$24.9',
        payType: 'Quarterly',
        payLevel: 2,
        productId: '214431',
        xMb: 30, //退款天数
        xPage: 'quarterly2',
        property: this.$t('language.paySystem.QuarterlyPayment'),
        includes: [{
          name: this.$t('language.paySystem.twoMonTrafficthree')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.moreSyncModes'),
          des: this.$t('language.popup.upgradeAccountPopup.syncSupported')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.offlinePremium')
        }, {
          name: this.$t('language.cloudSync.realSync')
        },
         {
          name: this.$t('language.popup.upgradeAccountPopup.scheduled')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferSpeed'),
          des: this.$t('language.popup.upgradeAccountPopup.greatlyIncreased')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.doubleSync'),
          des: this.$t('language.popup.upgradeAccountPopup.sameTime')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.filter'),
          des: this.$t('language.popup.upgradeAccountPopup.automatically')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferServer')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.customerSupport')
        }],
        summary: {
          sname: this.$t('language.paySystem.billed'),
          sDes: this.$t('language.paySystem.subCould')
        }
      },
      {
        paySysName: this.$t('language.paySystem.fourMOne'),
        flow: '400' + this.$t('language.paySystem.gb'),
        payMony: '$89.9',
        payType: 'Yearly',
        productId: '214432',
        xMb: 30, //退款天数
        xPage: 'yearly2',
        payLevel: 2,
        property: this.$t('language.paySystem.yearlyPayment'),
        includes: [{
          name: this.$t('language.paySystem.fourMTrafficOne')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.moreSyncModes'),
          des: this.$t('language.popup.upgradeAccountPopup.syncSupported')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.offlinePremium')
        },  {
          name: this.$t('language.cloudSync.realSync')
        },
        {
          name: this.$t('language.popup.upgradeAccountPopup.scheduled')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferSpeed'),
          des: this.$t('language.popup.upgradeAccountPopup.greatlyIncreased')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.doubleSync'),
          des: this.$t('language.popup.upgradeAccountPopup.sameTime')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.filter'),
          des: this.$t('language.popup.upgradeAccountPopup.automatically')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferServer')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.customerSupport')
        }],
        summary: {
          sname: this.$t('language.paySystem.billed'),
          sDes: this.$t('language.paySystem.subCould')
        }
      }
      ],
    }
  },
  computed:{
    schemes: function(){ 
        return {
          "free": [
            {
              "cartId" : "241015",
              "coupon" : "1N7-RVK-GLJ",
              "attrib" : 1,
              "type" : "Monthly",
              "level" : 2,
              "payMony" : {
                "USD":"$ 7.99",
                "ECU":"7,99 €",
                "BRL":"R$ 41",
                "JPY":"944 円",
                "TWD":"NT$ 229",
                "CNY":"¥ 51",
              },
              "oldPayMony" : {
                "USD":"$ 9.99",
                "ECU":"9,99 €",
                "BRL":"R$ 51",
                "JPY":"1,180 円",
                "TWD":"NT$ 286",
                "CNY":"¥ 64",
              },
              "parameters" : {
                "xPage" : "2023-new-year-monthly1-popup",
                "xLevel" : 2,
                "xGurantee" : 14,
                "xMb" : 14
              },
              "arguments" : {
                "cuppon" : 20,
                "title" : "monthly100GB"
              },
            },
            {
              "cartId" : "241023",
              "coupon" : "KUE-8KP-9BM",
              "attrib" : 2,
              "type" : "Yearly",
              "level" : 2,
              "payMony" : {
                "USD":"$ 49.99",
                "ECU":"49,99 €",
                "BRL":"R$ 255",
                "JPY":"5,905 円",
                "TWD":"NT$ 1,431",
                "CNY":"¥ 320",
              },
              "oldPayMony" : {
                "USD":"$ 119.88",
                "ECU":"119,88 €",
                "BRL":"R$ 612",
                "JPY":"14,160 円",
                "TWD":"NT$ 3,432",
                "CNY":"¥ 768",
              },
              "parameters" : {
                "xPage" : "2023-new-year-annual1-popup",
                "xLevel" : 2,
                "xGurantee" : 30,
                "xMb" : 30
              },
              "arguments" : {
                "cuppon" : 58,
                "title" : "yearly1200GB"
              },
            },
            {
              "cartId" : "241024",
              "coupon" : "TNM-Y75-NNK",
              "attrib" : 2,
              "type" : "Yearly",
              "level" : 1,
              "payMony" : {
                "USD":"$ 99",
                "ECU":"99 €",
                "BRL":"R$ 507",
                "JPY":"11,689 円",
                "TWD":"NT$ 2,832",
                "CNY":"¥ 632",
              },
              "oldPayMony" : {
                "USD":"$ 299",
                "ECU":"299 €",
                "BRL":"R$ 1,532",
                "JPY":"35,305 円",
                "TWD":"NT$ 8,554",
                "CNY":"¥ 1,908",
              },
              "parameters" : {
                "xPage" : "2023-new-year-annualun-popup",
                "xLevel" : 1,
                "xGurantee" : 30,
                "xMb" : 30
              },
              "arguments" : {
                "cuppon" : 67,
                "title" : "yearlyUnlimit"
              },
            },
            {
              "cartId" : "247484",
              "coupon" : "Z7U-1RJ-XL8",
              "attrib" : 2,
              "type" : "Lifetime",
              "level" : 1,
              "payMony" : {
                "USD":"$ 179",
                "ECU":"179 €",
                "BRL":"R$ 917",
                "JPY":"21,134 円",
                "TWD":"NT$ 5,121",
                "CNY":"¥ 1,142",
              },
              "oldPayMony" : {
                "USD":"$ 628",
                "ECU":"628 €",
                "BRL":"R$ 3,217",
                "JPY":"74,153 円",
                "TWD":"NT$ 17,967",
                "CNY":"¥ 4,007",
              },
              "parameters" : {
                "xPage" : "2023-new-year-lifetimeun-popup",
                "xLevel" : 1,
                "xGurantee" : 30,
                "xMb" : 30
              },
              "arguments" : {
                "cuppon" : 71,
                "title" : "lifetimeUnlimit"
              },
            }
          ],
          "yearDown": [
            //年以下付费
            {
              "cartId" : "241024",
              "coupon" : "TNM-Y75-NNK",
              "attrib" : 2,
              "type" : "Yearly",
              "level" : 1,
              "payMony" : {
                "USD":"$ 99",
                "ECU":"99 €",
                "BRL":"R$ 507",
                "JPY":"11,689 円",
                "TWD":"NT$ 2,832",
                "CNY":"¥ 632",
              },
              "oldPayMony" : {
                "USD":"$ 299",
                "ECU":"299 €",
                "BRL":"R$ 1,532",
                "JPY":"35,305 円",
                "TWD":"NT$ 8,554",
                "CNY":"¥ 1,908",
              },
              "parameters" : {
                "xPage" : "2023-new-year-annualun-promotion",
                "xLevel" : 1,
                "xGurantee" : 30,
                "xMb" : 30
              },
              "arguments" : {
                "cuppon" : 67,
                "title" : "yearlyUnlimit"
              },
            },
            {
              "cartId" : "247484",
              "coupon" : "Z7U-1RJ-XL8",
              "attrib" : 2,
              "type" : "Lifetime",
              "level" : 1,
              "payMony" : {
                "USD":"$ 179",
                "ECU":"179 €",
                "BRL":"R$ 917",
                "JPY":"21,134 円",
                "TWD":"NT$ 5,121",
                "CNY":"¥ 1,142",
              },
              "oldPayMony" : {
                "USD":"$ 628",
                "ECU":"628 €",
                "BRL":"R$ 3,217",
                "JPY":"74,153 円",
                "TWD":"NT$ 17,967",
                "CNY":"¥ 4,007",
              },
              "parameters" : {
                "xPage" : "2023-new-year-lifetimeun-promotion",
                "xLevel" : 1,
                "xGurantee" : 30,
                "xMb" : 30
              },
              "arguments" : {
                "cuppon" : 71,
                "title" : "lifetimeUnlimit"
              },
            }
          ],
          "year1": [
            //年一
            {
              "cartId" : "240899",
              "coupon" : "9XL-DRB-AZC",
              "attrib" : 2,
              "type" : "Yearly",
              "level" : 1,
              "payMony" : {
                "USD":"$ 59",
                "ECU":"59 €",
                "BRL":"R$ 302",
                "JPY":"6,966 円",
                "TWD":"NT$ 1,688",
                "CNY":"¥ 376",
              },
              "oldPayMony" : {
                "USD":"$ 299",
                "ECU":"299 €",
                "BRL":"R$ 1,532",
                "JPY":"35,305 円",
                "TWD":"NT$ 8,554",
                "CNY":"¥ 1,908",
              },
              "parameters" : {
                "xPage" : "2023-new-year-annualun-upgrade",
                "xLevel" : 1,
                "xGurantee" : 30,
                "xMb" : 30
              },
              "arguments" : {
                "cuppon" : 80,
                "title" : "yearlyUnlimit"
              },
            },
            {
              "cartId" : "247485",
              "coupon" : "TG1-SRS-B47",
              "attrib" : 2,
              "type" : "Lifetime",
              "level" : 1,
              "payMony" : {
                "USD":"$ 119",
                "ECU":"119 €",
                "BRL":"R$ 610",
                "JPY":"14,052 円",
                "TWD":"NT$ 3,405",
                "CNY":"¥ 759",
              },
              "oldPayMony" : {
                "USD":"$ 628",
                "ECU":"628 €",
                "BRL":"R$ 3,217",
                "JPY":"74,153 円",
                "TWD":"NT$ 17,967",
                "CNY":"¥ 4,007",
              },
              "parameters" : {
                "xPage" : "2023-new-year-lifetimeun-upgrade",
                "xLevel" : 1,
                "xGurantee" : 30,
                "xMb" : 30
              },
              "arguments" : {
                "cuppon" : 82,
                "title" : "lifetimeUnlimit"
              },
            }
          ],
          "year2": [
            //其他非无限年
            {
              "cartId" : "240902",
              "coupon" : "HXT-XXN-Z1Z",
              "attrib" : 2,
              "type" : "Yearly",
              "level" : 1,
              "payMony" : {
                "USD":"$ 19",
                "ECU":"19 €",
                "BRL":"R$ 97",
                "JPY":"2,242 円",
                "TWD":"NT$ 543",
                "CNY":"¥ 121",
              },
              "oldPayMony" : {
                "USD":"$ 299",
                "ECU":"299 €",
                "BRL":"R$ 1,532",
                "JPY":"35,305 円",
                "TWD":"NT$ 8,554",
                "CNY":"¥ 1,908",
              },
              "parameters" : {
                "xPage" : "2023-new-year-annualun-upgrade",
                "xLevel" : 1,
                "xGurantee" : 30,
                "xMb" : 30
              },
              "arguments" : {
                "cuppon" : 94,
                "title" : "yearlyUnlimit"
              },
            },
            {
              "cartId" : "247486",
              "coupon" : "9FP-54Q-EFF",
              "attrib" : 2,
              "type" : "Lifetime",
              "level" : 1,
              "payMony" : {
                "USD":"$ 79",
                "ECU":"79 €",
                "BRL":"R$ 405",
                "JPY":"9,328 円",
                "TWD":"NT$ 2,260",
                "CNY":"¥ 504",
              },
              "oldPayMony" : {
                "USD":"$ 628",
                "ECU":"628 €",
                "BRL":"R$ 3,217",
                "JPY":"74,153 円",
                "TWD":"NT$ 17,967",
                "CNY":"¥ 4,007",
              },
              "parameters" : {
                "xPage" : "2023-new-year-lifetimeun-upgrade",
                "xLevel" : 1,
                "xGurantee" : 30,
                "xMb" : 30
              },
              "arguments" : {
                "cuppon" : 87,
                "title" : "lifetimeUnlimit"
              },
            }
          ],
          "Unlimit": [
            //无限
            {
              "cartId" : "247487",
              "coupon" : "VV1-3CA-AV6",
              "attrib" : 2,
              "type" : "Lifetime",
              "level" : 1,
              "payMony" : {
                "USD":"$ 59",
                "ECU":"59 €",
                "BRL":"R$ 302",
                "JPY":"6,963 円",
                "TWD":"NT$ 1,687",
                "CNY":"¥ 376",
              },
              "oldPayMony" : {
                "USD":"$ 628",
                "ECU":"628 €",
                "BRL":"R$ 3,217",
                "JPY":"74,153 円",
                "TWD":"NT$ 17,967",
                "CNY":"¥ 4,007",
              },
              "parameters" : {
                "xPage" : "2023-new-year-lifetimeun-upgrade",
                "xLevel" : 1,
                "xGurantee" : 30,
                "xMb" : 30
              },
              "arguments" : {
                "cuppon" : 91,
                "title" : "lifetimeUnlimit"
              },
            }
          ]
        }
    },
  },
  mounted () {
    let user = commonUtils.getUser();
    if (!user || !user.id) {
      this.$router.push('/turnLoginPage');
    }
    this.initShowData(); //默认显示第一页
    this.$router.push('/mc_project/paySys');
  },
  watch:{
    clickIndex(newV,oldV){
      this.changeAllowSchemes();
    },
    // '$store.state.updateUserSchems': function (newValue, oldValue) {
    //   if (newValue) {
    //     this.initShowData();
    //     this.$store.commit("setUpdateUserSchems", false);
    //   }
    // },
  },
  components: {
    bindEmailDialog,
    payDiffDialog,
    payErrorNoticeDialog,
    bindEmailJumpDialog,
    paySchemeTab,
    nowPaySchemeDialog,
    iosPayTipDialog,
    appNowPaySchemeDialog
  },
  methods: {
    getTitleImg(){
      var lang = commonUtils.getLocaleToIndex(localStorage.getItem("locale"));
      return require('../../assets/images/newYear-2023/img_defray_title_'+lang+'.png');
    },
    getBottonWidth(){
    let result;
    switch (this.$i18n.locale) {
      case 'english':
        result = "240px";
        break;
      case 'deutsch':
        result = "280px";
        break;
      case 'france':
        result = "280px";
        break;
      case 'portuguese':
        result = "250px";
        break;
      case 'spanish':
        result =  "260px";
        break;
      case 'italian':
        result = "260px";
        break;
      case 'japanese':
        result = "280px";
        break;
      case 'traditionalChinese':
        result = "220px";
        break;
      case 'chinese':
        result = "220px";
        break;
    }
    return result;
    },
    getBackClass () {
      let result;
      switch (this.$i18n.locale) {
        case 'english':
          result = "back-en";
          break;
        case 'deutsch':
          result = "back-de";
          break;
        case 'france':
          result = "back-fr";
          break;
        case 'portuguese':
          result = "back-por";
          break;
        case 'spanish':
          result = "back-spa";
          break;
        case 'italian':
          result = "back-it";
          break;
        case 'japanese':
          result = "back-ja";
          break;
        case 'traditionalChinese':
          result = "back-tw";
          break;
        case 'chinese':
          result = "back-cn";
          break;
      }
      return result;
    },
    getTxtWidth (item, jIndex) {
      let result;
      if (item.productId == '226093' && this.clickIndex == 0 && !this.user.vip) {
        result = 'questionTxtWidth-min';
      }
      return result;
    },
    //实时修改当前展示套餐
    changeAllowSchemes(){
      this.allowSchemes = this.allSchemes[this.clickIndex];
    },
    changeChoosePlan (index) {
      this.clickIndex = index;
    },
    //根据条件筛选套餐
    filterVipSchemes(vipSchemes){
      if(!vipSchemes){
        return;
      }
      this.allSchemes = [];
      let limitedVip = [];//有限套餐或流量包
      let unlimitedVip = [];//无限套餐 
      if(!this.user.vip){
        //免费用户
        vipSchemes.forEach(function (item,index) {
          if(item.level == 2){
            limitedVip.push(item);
          }else if(item.level == 1){
            unlimitedVip.push(item);
          }
        })
        this.num = 71;
      }else if(this.user.payLevel>1){
        //有限年用户
        limitedVip = this.limitedOtherPlan;
        unlimitedVip = vipSchemes;
        if(this.user.payType=="Yearly"){
          //获取用户套餐信息
          this.Utils.doSubscriptionPostRequest('get_by_user', { ud: this.user.id }).then(res => {
              if(res.nowScheme){
                  //有等效id使用等效id
                  let vipId = res.nowScheme.equivalentVip?res.nowScheme.equivalentVip:res.nowScheme.id;
                  if(vipId=="2990c54096364a38a0e115f5602385be"){
                      //年1
                      this.num = 82;
                  }else{
                      //年2
                      this.num = 87;
                  }
              }
          });
        }else{
          this.num = 71;
        }
      }else if(this.user.payLevel==1){
        unlimitedVip = vipSchemes;
        if(this.user.payType=="Monthly"){
          //无限月
          this.num = 71;
        }else{
          //年无限用户
          this.num = 91;
        }
      }
      this.allSchemes = [
        limitedVip,
        unlimitedVip,
      ]
      this.changeAllowSchemes();
      this.$forceUpdate();
    },
    //初始化显示数据
    initShowData () {
      let that = this;
      this.user = commonUtils.getUser();
      if(this.user.vip&&this.user.payType == 'Lifetime'){
        that.$parent.$refs.leftBanner.menuOptionSelect(10);
        that.$router.push({
          name: "addCloud"
        });
      }
      let paySysRes = this.$store.getters.getPaySysRes;
      if(paySysRes!=null&&!that.nowScheme){
        //本页面未加载过时加载
        if(paySysRes.nowScheme!={}&&paySysRes.nowScheme!=null&&paySysRes.nowScheme.id){
          //如果非免费用户
          this.setNowScheme(paySysRes);
        }else{
          //免费用户只需要根据条件筛选套餐
          this.filterVipSchemes(this.schemes.free);
        }
      }
      this.Utils.doSubscriptionPostRequest('get_by_user', { ud: this.user.id }).then(res => {
        //如果请求成功
        that.setNowScheme(res);
        that.$forceUpdate();
        //缓存信息
        that.$store.commit("setPaySysRes", res);
      });
      if(this.user.vip){
        //初始化用户当前信息
        this.getItemSubScrition();
      }
    },
    setNowScheme(res){
      if (res.message == 'success' && res.vipSchemes) {
        //终身无限则退出页面
        if(res.nowScheme.type == 'Lifetime'){
          this.$parent.$refs.leftBanner.menuOptionSelect(10);
          this.$router.push({
            name: "addCloud"
          });
        }
        if(!this.user.vip || res.nowScheme.attrib == 0){
          //如果是老套餐则用
          this.user = commonUtils.getUser();
          if (this.user.vip) { //如果不是免费用户
            if (this.user.payLevel > 1) { //大于1为有限，如果为有限月，有限季，有限年用户
              //显示升级的后两项
              this.nowData = this.dataJson.slice(2);
              //计算若选择年无限应该付的金额
              if (this.user.payType == 'Monthly') {
                this.nowData.unshift(this.dataJson[1]);
              } else if (this.user.payType == 'Quarterly') {
                this.nowData.unshift(this.freeOtherPlan[1]);
              } else {
                //有限年套餐去掉无限年
                this.nowData.splice(0,1);
                this.nowData.unshift(this.freeOtherPlan[2]);
              }
              getCurrencyUtils.switchActivityMoneyType(this,'limited');
            } else { //如果为无限
              if (this.user.payType == 'Monthly') { //如果为无限月
                this.nowData = this.dataJson.slice(2, this.dataJson.length);
                this.nowData.unshift(this.monthlyUnlimited);
                getCurrencyUtils.switchActivityMoneyType(this,'UnlimitedMonthly');
              }
              if (this.user.payType == 'Yearly') { //如果为无限年
                this.nowData = this.dataJson.slice(2, this.dataJson.length);
                getCurrencyUtils.switchActivityMoneyType(this,'UnlimitedYearly');
              }
            }
            
            this.nowScheme = {
              type: this.user.payType,
              payMony: this.nowData[0].payMony,
              name: this.nowData[0].paySysName
            };
          } else { //如果用户是免费用户
            this.nowData = this.dataJson;
            this.nowData[0].currentPlan = true;
            getCurrencyUtils.switchActivityMoneyType(this,'free');
          }
        }else{
          this.nowScheme = res.nowScheme;
          let lang = commonUtils.getPriceForLange(localStorage.getItem("locale"));
          this.nowScheme.name = this.$t('language.paySystem.arguments.title.'+res.nowScheme.arguments['title']);
          if(this.nowScheme.isDifferencePrice==1){
            //增值服务显示原价
            this.nowScheme.payMony = this.nowScheme.payMony['basic'][lang];
          }else{
            this.nowScheme.payMony = this.nowScheme.payMony[lang];
          }
        }

        //刷新套餐
        this.clickIndex = 1;
        if(!this.user.vip){
          //免费用户
          this.filterVipSchemes(this.schemes.free);
        }else if(this.user.payType!="Yearly"&&this.user.payType!="Lifetime"){
          //年以下
          this.filterVipSchemes(this.schemes.yearDown);
        }else if(this.user.payType=="Yearly"&&this.user.payLevel>1){
          //有限年
          let vipId = res.nowScheme.equivalentVip?res.nowScheme.equivalentVip:res.nowScheme.id;
          if(vipId=="2990c54096364a38a0e115f5602385be"){
              //年1
              this.filterVipSchemes(this.schemes.year1);
          }else{
              //年2
              this.filterVipSchemes(this.schemes.year2);
          }
        }else if(this.user.payType!="Lifetime"){
            //无限用户
            this.filterVipSchemes(this.schemes.Unlimit);
        }
      }
    },
    upgradePlan (item) {
      let that = this;
      //每次打开界面获取的最新用户信息
      that.user = commonUtils.getUser();
      if (!that.user || !that.user.id) {//如果userid不存在则不进行跳转
        that.$toast({
          text: this.$t('language.common.getAccountInfo'),
          type: 'notice',
          idValue: 'rightContBan',
          learnMoreShow: false
        });
        return false;
      }
      commonUtils.refreshUserInfo(this, function (result) {
        that.user = result;
        //ios订单号前四位为2000,而且不是购买流量包
        if(that.user.vip&&(item.xLevel!=3)&&(that.user.subscrId.substr(0,2) == "20" || that.user.subscrId.substr(0,1) == "3")){
          //获取ios用户订阅状态
          that.Utils.doSubscriptionPostRequest('get_state_ios', {
            ud: that.user.id,
            salt: that.user.salt
          }).then(response => {
            if(response[0]&&response[0].autoRenewStatus == 1){
              that.$refs.iosPayTipDialog.iosPayTipShow = true;
              that.$refs.iosPayTipDialog.payInfo = {
                name: that.nowScheme.name,
                appleId: response[0].originalTransactionId,
              };
            }else{
              that.openCbPayPage(item);
            }
          })
        }else{
          that.openCbPayPage(item);
        }
      });
    },
    //打开cb支付页面
    openCbPayPage(item) {
      var that = this;
      //检测用户是否绑定邮箱，如果未绑定邮箱则打开绑定邮箱界面
      if (!commonstate.emailpattern.test(that.user.email)) {
        that.sendGAEvent(item);
        paySysUtils.openBindEmailPage(that,item,"paySys");
        return false;
      }
      let lang = commonUtils.getLocaleTo(localStorage.getItem("locale"));
      if (that.checkCycleType == 0 && item.xLevel == 2 && item.productId == "241015") { //如果点击的是有限月的按钮
      that.Utils.doUserHaveLoginRequest('getUpShellActiveTime', {
          ud: that.user.id,
          salt: that.user.salt
      }).then(response => {
        var upShellActiveTime = response.upShellActiveTime;
        // let key = 'monthLy' + that.user.id; //计算时间差是否超过了24小时
        let firstTime = upShellActiveTime; //首次点击页面时间
        let nowDateStr = commonUtils.getNowDateFormat();
        let dateTime = nowDateStr.replace(new RegExp("-", "gm"), "/");
        let nowDateLong = new Date(dateTime).getTime(); //现在时间
        let timeDiff;
        let downTime; //倒计时时间
        let page = "monthly3";
        let label1 = "monthly1";
        let label2 = "-0-original";
        that.getUserStatus(); //开始检测用户的状态
        if (firstTime) {
          timeDiff = nowDateLong - firstTime;
          if (timeDiff > 86400000) { //如果超过了24小时
            // 取得要提交页面的URL
            label2 = "o-original";
            //GA打点记录
            googleAnalyticsUtil.pay2(that, label1+label2);
            var action = commonstate.cbLinkUrl + '/1533/purl-mc-cart?x-linkid=' + lang + '';
            commonUtils.packageFormAndSubmit(action, item, that.user);
            that.getUserStatus(); //开始检测用户的状态
          } else { //进入倒计时界面
            //GA打点记录
            googleAnalyticsUtil.pay2(that, label1+label2);
            downTime = 86400 - parseInt((new Date(dateTime).getTime() - firstTime) / 1000);
            //活动使用monthly3
            let link = '/monthly-unlimited-web.html?id=' + that.user.id + '&time=' + downTime + '&lang=' +
              lang + '&page='+page;
            let language = commonUtils.getLocaleToIndex(that.$i18n.locale);
            if (language != 'en') {
              window.open(commonstate.frontEndUrl + '/' + language + link, '_blank');
            } else {
              window.open(commonstate.frontEndUrl + link, '_blank');
            }
          }
        } else { //进入倒计时界面
          // localStorage.setItem(key, nowDateLong);
          //把值存入数据库
          let changeData = {
            ud: that.user.id,
            upShellActiveTime: nowDateLong,
          }
            that.Utils.doUserHaveLoginRequest("saveUpShellActiveTime", changeData).then(res => { });
          let link = '/monthly-unlimited-web.html?id=' + that.user.id + '&time=' + 86400 + '&lang=' + lang +
            //'&page=monthly1';新春活动默认为3
            '&page='+page;
          let language = commonUtils.getLocaleToIndex(that.$i18n.locale);
          if (language != 'en') {
            window.open(commonstate.frontEndUrl + '/' + language + link, '_blank');
          } else {
            window.open(commonstate.frontEndUrl + link, '_blank');
          }
        }
        commonUtils.refreshUserInfo(that, function (res) { });
        });
      } else {
        if (that.user.payType && that.user.vip) {
          //如果用户是无限年，即从无限年升级到终身无限版本
          if (that.user.payType == 'Yearly' && that.user.payLevel == 1) {
            //item.payMony = '$ 89.9'; 
            that.$forceUpdate();
          } else if (item.payType == 'Yearly' && item.payLevel == 1) {
            item.loading = true;
            that.$forceUpdate();
            if (!that.sendSubScribeRequest) {//如果已向后端发送了请求则立马返回
              return;
            }
            that.getItemSubScrition(item);
            return;
          }
        }
        that.sendGAEvent(item);
        // 取得要提交页面的URL
        var action = commonstate.cbLinkUrl + '/1533/purl-mc-cart?x-linkid=' + lang + '';
        commonUtils.packageFormAndSubmit(action, item, that.user);
        commonUtils.refreshUserInfo(that, function (res) { });
        that.getUserStatus(); //开始检测用户的状态
      }
    },
    getUserStatus () { ///通过获取最新的User判断user是否已经状态改变，如果状态改变则刷新界面
      let oldUser = this.user;
      let that = this;
      let newUser;
      let oldPassword;
      let t;
      this.Utils.doUserHaveLoginRequest('get', {
        ud: oldUser.id,
        salt: oldUser.salt
      }).then(response => {
        that.requestNum = that.requestNum + 1;
        newUser = response.user;
        if (!oldUser.password) {
          delete newUser.password;
        } else {
          oldPassword = oldUser.password;
        }
        that.$store.commit('setPassWord', response.user.password);
        var result = commonUtils.Compare(oldUser, newUser);
        if (that.requestNum == 80) { //如果请求了50次则取消请求
          clearTimeout(t);
          return false;
        }
        if (result != false) { //如果结果是相等则过2秒再进行请求
          t = setTimeout(() => {
            that.getUserStatus();
          }, 2500);
        } else { //如果用户状态已改变
          clearTimeout(t);
          if (oldPassword) {
            newUser.password = oldPassword;
          } else {
            delete newUser.password;
          }
          localStorage.setItem("user", JSON.stringify(newUser));
          that.$cookies.set("user",JSON.stringify(newUser),"7d");
        if(newUser.vip){
            if(!(newUser.payType == 'Yearly' && newUser.payLevel >1)){
              localStorage.removeItem("newPayMoney");
              that.initShowData();
            }else{
              that.initShowData();
            }
         }
          if(newUser.vip&&newUser.payStatus=="Canceled"){
            that.initShowData();
          }
          // 付费升级全局缓存标记
          that.$store.commit("setPayUpgrade", true);
          that.$store.state.normalPayUpgrade=true;
          if (that.$parent && that.$parent.$refs.rightContBan) {
            that.$parent.$refs.rightContBan.funnelShow = false; //不显示漏斗
            //关闭限时购买弹窗后再出现通知信息
            that.$parent.$refs.limitedSaledDialog.timeSaleShow = false;
            that.$parent.$refs.limitedSaledDialog.contentShow = false;
            that.$parent.$refs.limitedSaledDialog.contentUnlimiedShow = false;
            if (that.$parent.$refs.rightContBan.letNotificationsShow) {
              that.$parent.$refs.rightContBan.$refs.notificationsDialog.notificationsShow = true;
              that.$parent.$refs.rightContBan.$refs.notificationsDialog.contentShow = true;
              that.$parent.$refs.rightContBan.letNotificationsShow = false;
              commonUtils.updateViewTime();
            }
            that.$parent.$refs.rightContBan.email = newUser.email;
            that.$parent.$refs.rightContBan.usedTraffic = newUser.usedBytes;
            // if (newUser.vip && newUser.payLevel > 1) {
            //   that.$parent.$refs.rightContBan.usedTraffic = newUser.payUsedTraffic;
            // }
            that.$parent.$refs.rightContBan.totalTraffic = newUser.totalBytes;
            commonUtils.createPayBtn(newUser, that.$parent.$refs.rightContBan);
          }
          that.user = newUser;
          if (newUser.payLevel <= 1) {
            if (newUser.payType == 'Lifetime') {
              that.$parent.$refs.leftBanner.menuOptionSelect(10);
              that.$router.push({
                name: "addCloud"
              });
            }
          }
          //本页的页面也应该改变
            that.clickIndex = 1;
            that.$forceUpdate();
        }
      });
    },
    backHistory () {
      //返回上一级目录
      history.go(-1);
    },
    sendGAEvent (item) {
      let that = this;
      if (that.user.vip) {
        //VIP用户升级
        if (item.productId == "214433") {
          googleAnalyticsUtil.pay2(that, "yearly-un3");
        }else
        if (item.productId == "226093") {
          googleAnalyticsUtil.pay2(that, "life-un3");
        }else
        // 流量包
        if (item.productId == "214087") {
          googleAnalyticsUtil.pay2(that, "50g");
        }else
        if (item.productId == "214088") {
          googleAnalyticsUtil.pay2(that, "100g");
        }else{
          googleAnalyticsUtil.pay2(that, item.xPage);
        }
      } else {
        //Free用户订购
        if (item.productId == "214430") {
          googleAnalyticsUtil.pay2(that, "monthly2-0");
        }else
        if (item.productId == "214431") {
          googleAnalyticsUtil.pay2(that, "quarterly2");
        }else
        if (item.productId == "214432") {
          googleAnalyticsUtil.pay2(that, "yearly2");
        }else
        if (item.productId == "214433") {
          googleAnalyticsUtil.pay2(that, "yearly-un2");
        }else
        if (item.productId == "226093") {
          googleAnalyticsUtil.pay2(that, "Life-un2");
        }else{
          googleAnalyticsUtil.pay2(that, item.xPage);
        }
      }
    },
        //获取用户的订阅
    getItemSubScrition (item) {
      this.sendSubScribeRequest = false;
      var subId = this.user.subscrId;
      if(this.user.subscrId.indexOf('-')>0){
          subId = this.user.subscrId.slice(0, this.user.subscrId.indexOf('-'));
      }
      let lang = commonUtils.getLocaleTo(localStorage.getItem("locale"));
      this.$refs.nowPaySchemeDialog.payInfo.subId = subId;
      // this.$refs.nowPaySchemeDialog.source='activity';
      var self = this;
      // this.$nextTick(()=>{
      //   self.$refs.nowPaySchemeDialog.updateItemPreview();
      // });
      this.Utils.doCbSubscriptionPostRequest('get_by_id', { subscriptionId: subId }).then(res => {
        //如果请求成功
        //item.loading = false;
        if (res.ResultMessage == 'OK') {
          let nowSchemePopup = self.$refs.nowPaySchemeDialog;
          let paymentInfo = res.Subscription.PaymentInfo;

          //获取最新的purchaseId
          let purchaseId = this.getNewPurchaseId(res);

          nowSchemePopup.payInfo.purchaseId = purchaseId;
          nowSchemePopup.payInfo.subId = subId;
          nowSchemePopup.payInfo.nextPayTime = lang=='en'?commonUtils.transferTime(this.user.overTime):commonUtils.transferForMatTime(this.user.overTime);
          nowSchemePopup.getPayInfo();
          if (paymentInfo != null) {
            nowSchemePopup.payInfo.payMethod = paymentInfo.PaymentType;
            nowSchemePopup.payInfo.lastFourNumber = paymentInfo.CardLastFourDigits;
          } else {
            self.getPurchaseV1(purchaseId);
          }
        
        }
      });
    },
    //获取最新的purchaseId
    getNewPurchaseId(res) {
      let newSub = res.Subscription.Items[0];
          if(res.Subscription.Items.length>1){
            let sub;
            for(sub of res.Subscription.Items){
              //isCurrent为true
              if(sub.isCurrent){
                newSub = sub;
                break;
              }
            }
          }
          let newPur = newSub.SubscriptionPurchaseItems[0];
          if(newSub.SubscriptionPurchaseItems.length>1){
            let pur;
            for(pur of newSub.SubscriptionPurchaseItems){
              //id最大
              if(pur.PurchaseId>newPur.PurchaseId){
                newPur = pur;
              }
            }
          }
          return newPur.PurchaseId;
    },
    getPurchaseV1 (purchaseId) {
      var self = this;
      this.Utils.doCbSubscriptionPostRequest('get_by_purchaseId', { purchaseId: purchaseId }).then(res => {
        //如果请求成功
        if (res.ResultMessage == 'OK') {
          if (res.Purchase.PaidOrderNotification.Purchase.PaymentInfo != null) {
            let paymentInfo = res.Purchase.PaidOrderNotification.Purchase.PaymentInfo;
            self.$refs.nowPaySchemeDialog.payInfo.payMethod = paymentInfo.PaymentType;
          }
        }
      });
    },
  }
}
</script>

<style scoped>

.item-sys-right {
  float: left;
  cursor: pointer;
  max-width: 235Px;
}

#paySystemActivity .oldPayMony {
  float: right;
  position: absolute;
  right:40Px;
  font-size: 16Px;
  top: 10Px;
  color: #304dc5;
  text-decoration: line-through;
  font-weight: normal;
}

.item-bottom-right {
  max-width: 300Px;
}

.paySys-body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 25Px;
  height: calc(100% - 60Px);
  position: relative;
  top: 60Px;
  background-color: #f2f7fe;
}

.questionTxtWidth {
  width: 125Px !important;
}

.paysys-box {
  width: 100%;
  height: 100%;
  border: 1Px solid #cdddf5;
  background: url("../../assets/images/christmasSaled-2022/bg_defray.png");
  overflow-y: auto;
}

/*定义滑块，内阴影及圆角*/
.paysys-box::-webkit-scrollbar {
  width: 8Px;
  /*no*/
  height: 8Px;
  /*no*/
  background-color: #fff;
}

.paysys-box::-webkit-scrollbar-thumb {
  min-height: 5Px;
  /*no*/
  border-radius: 5Px;
  /*no*/
  background-color: #becae4;
}

#paySystemActivity .paysys-title {
  width: 100%;
  text-align: center;
  height: 50Px;
  font-weight: bold;
  font-size: 30Px;
  color: #1a1a1a;
  line-height: 35Px;
}

.paySwitch {
  width: 100%;
  float: left;
  text-align: center;
  position: relative;
}

.switch-all {
  display: inline-flex;
  height: 50Px;
  width: min-content;
  vertical-align: middle;
  margin: 7Px auto 40Px;
  color: #D61A00;
  background-color: #F5E4E1;
  border-radius: 25Px;
  user-select: none;
}

.switch-all span {
  margin: 0 25Px;
}

#paySystemActivity .switch-left,
#paySystemActivity .seitch-right {
  min-width: 220Px;
  float: left;
  height: 50Px;
  cursor: pointer;
  text-align: center;
  line-height: 50Px;
  font-size: 18Px;
}

#paySystemActivity .switch-click {
  background-color: #D61A00;
  color: #fff;
  font-size: 18Px;
  border-radius: 25Px;
}

.paySys-bottom {
  min-height: 430Px;
  width: 100%;
  float: left;
  position: relative;
  text-align: center;
}

.paysys-div {
  width: 300Px;
  border-radius: 20Px;
  height: calc(100% - 20Px);
  float: left;
  box-shadow: -2Px 5Px 8Px 1Px #bababa85;
  /*no*/
  box-sizing: border-box;
  position: relative;
}

.sys-weight-bold {
  font-weight: bold;
}

.paysys-div-all {
  height: 100%;
  margin: auto;
  display: inline-block;
}

.paysys-div-margin {
  margin-right: 20Px;
}

.paysys-up {
  width: 100%;
  height: 43%;
  float: left;
}

.paysys-down {
  width: 100%;
  height: 57%;
  float: left;
  box-sizing: border-box;
  padding: 15Px 15Px 20Px 15Px;
  position: relative;
}

.paysys-up-title {
  text-align: center;
  font-weight: 400;
  font-size: 24Px;
  color: #1a1a1a;
  margin-top: 6%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
}

#paySystemActivity .paysys-up-on {
  height: 50%;
  padding: 0;
  position: relative;
  background-color: #f1f1f1;
  padding-top: 5Px;
  box-sizing: border-box;
}

#paySystemActivity .paysys-up-on:after {
  background-color: #f1f1f1;
  content: '';
  width: 100%;
  height: 30%;
  position: absolute;
  left: 0%;
  top: 84.5%;
  border-radius: 0 0 55% 55%;
}

.paysys-up-purple {
  height: 50%;
  padding: 0;
  position: relative;
  background-color: #dee9fb;
  padding-top: 5Px;
  box-sizing: border-box;
}

.paysys-up-purple:after {
  background-color: #dee9fb;
  content: '';
  width: 100%;
  height: 30%;
  position: absolute;
  left: 0%;
  top: 84.5%;
  border-radius: 0 0 55% 55%;
}

.paysys-up-txt {
  text-align: center;
  font-size: 12Px;
  margin-top: 2%;
  color: rgb(0, 0, 0.6);
}

.paysys-up-price {
  text-align: center;
  top: 50%;
  font-size: 48Px;
  font-weight: bold;
  color: #5562b4;
  position: absolute;
  z-index: 3;
  margin: auto;
  left: 0;
  right: 0;
}

#paySystemActivity .paysys-up-payType {
  text-align: center;
  bottom: -6%;
  font-size: 14Px;
  position: absolute;
  z-index: 3;
  margin: auto;
  left: 0;
  right: 0;
  color: #304dc5;
}

.paysys-up-down {
  position: relative;
  top: 12%;
  text-align: center;
  width: 100%;
  height: 35%;
}

#paySystemActivity .up-down-payMony {
  font-size: 26Px;
  font-weight: bold;
  color: #304dc5;
}

#paySystemActivity .paysys-property {
  font-size: 14Px;
  height: 15Px;
  text-align: center;
  top: 85%;
  position: absolute;
  z-index: 3;
  margin: auto;
  left: 0;
  right: 0;
  color: #304dc5;
}

.paysys-button {
  min-width: 115Px;
  height: 30Px;
  vertical-align: middle;
  display: inline-block;
  text-align: center;
  line-height: 30Px;
  border-radius: 3Px;
  cursor: pointer;
  padding: 0 10Px 0 10Px;
  /* Chrome all / Safari all /opera15+*/ 
-webkit-user-select: none;   
/* Firefox all */  
-moz-user-select: none;     
/* IE 10+ */ 
-ms-user-select: none;       
/* 通用 */
user-select: none;  
}

#paySystemActivity .cborder {
  border: 1Px solid #dee9fb;
  cursor:auto !important;
}

.uborder {
  color: #fff;
}

.paysys-down-des {
  font-weight: bold;
  font-size: 12Px;
  margin-bottom: 15Px;
}

.down-summary-des {
  font-weight: bold;
  font-size: 12Px;
  position: absolute;
  bottom: 10Px;
  margin: 0 auto;
  left: 0;
  right: 0;
}

.paysys-down-line {
  width: 100%;
  font-size: 12Px;
  float: left;
  margin-bottom: 8Px;
}

.down-summary {
  position: absolute;
  bottom: 0;
  margin-bottom: 10Px;
}

.downs-summarys {
  float: left;
  width: 100%;
  height: 20Px;
  text-align: center;
}

.up-down-center {
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 30Px;
}

.down-des-for {
  margin-left: 10Px;
  float: left;
}

.paysys-all {
  width: 100%;
  max-height: 900Px;
  min-width: 1371Px;
  height: 100%;
  position: relative;
}

.sys-questionTxt {
  width: 200Px;
  display: none;
  position: absolute;
  border: 1Px solid #5562b4;
  border-radius: 3Px;
  left: 20Px;
  top: 2Px;
  background: #fff;
  z-index: 3;
  font-size: 12Px;
  box-sizing: border-box;
  padding: 5Px;
  line-height: 20Px;
}

.sys-bottomTxt {
  width: 160Px;
  display: none;
  position: absolute;
  border: 1Px solid #5562b4;
  border-radius: 3Px;
  left: 20Px;
  bottom: 0Px;
  background: #fff;
  z-index: 3;
  font-size: 12Px;
  box-sizing: border-box;
  padding: 5Px;
  line-height: 20Px;
  font-weight: 100;
}

.plan-question:hover .sys-questionTxt,
.plan-question:hover .sys-bottomTxt {
  display: block;
}

.current-month {
  font-weight: bold;
  margin-bottom: 15Px;
}

.current-box {
  width: 770Px;
  height: 15Px;
  border: 1Px solid #a9baff;
  vertical-align: middle;
  margin: auto;
  text-align: center;
  font-size: 14Px;
  position: relative;
  margin-bottom: 40Px;
}

#paySystemActivity .sys-progress-bar {
  background-color: #5562b4;
  height: 100%;
  max-width: 100%;
  text-align: center;
}

.sys-traffic {
  position: absolute;
  left: 0;
  right: 0;
  top: -1Px;
}

.current-plan {
  width: 270Px;
  height: calc(100% - 20Px);
  -webkit-box-shadow: -2Px 5Px 8Px 0.1Px #bababa85;
  box-shadow: -2Px 5Px 8Px 0.1Px #bababa85;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 250Px;
  float: left;
}

#paySystemActivity .paysys-expir {
  font-size: 14Px;
  height: 15Px;
  text-align: center;
  bottom: -25Px;
  position: absolute;
  z-index: 3;
  margin: auto;
  left: 0;
  right: 0;
  color: #304dc5;
}

.current-plans {
  vertical-align: middle;
  margin: auto;
  height: 300Px;
}

.current-plan-purple {
  height: 110Px;
  padding: 0;
  position: relative;
  background-color: #dee9fb;
  padding-top: 5Px;
  box-sizing: border-box;
}

.current-plan-purple:after {
  background-color: #dee9fb;
  content: '';
  width: 100%;
  height: 20Px;
  position: absolute;
  left: 0%;
  top: 110Px;
  border-radius: 0 0 55% 55%;
}

.current-plan-paySysName {
  margin-top: 20Px;
  font-weight: bold;
  font-size: 20Px;
}

.plan-paySysName-bottom {
  position: absolute;
  z-index: 3;
  margin: auto;
  left: 0;
  right: 0;
  top: 86%;
}

.up-down-eachGb {
  font-size: 12Px;
  margin: 5Px 0 0 0;
}

.lItem-summary {
  font-size: 12Px;
  width: 155Px;
  margin: auto;
  vertical-align: middle;
  position: relative;
  top: 13Px;
  line-height: 15Px;
}

.grey-hr {
  width: calc(100% - 40Px);
  height: 1Px;
  border-bottom: 1Px solid#F6F6F6;
  vertical-align: middle;
  margin: auto;
  float: left;
  margin-left: 20Px;
}

.sysLink:hover {
  text-decoration: underline;
}

.paySys-bottom-unlimit {
  top: 8Px;
}

.paySys-bottom-tips{
  position: relative;
  top: 70Px;
}
.paySys-up-margin {
  top: 20Px;
}

.special-up {
  color: #fff;
  width: 100%;
  height: 30Px;
  text-align: center;
  position: absolute;
  z-index: 3;
  top: -20Px;
  line-height: 30Px;
}

#paySystemActivity .sys-back-button {
  margin-left: 28Px;
  height: 30Px;
  float: left;
  position: relative;
  top: 30Px;
  text-align: center;
  line-height: 30Px;
  color: #5562b4;
  cursor: pointer;
  margin-bottom: 10Px;
  display: flex;
}

#paySystemActivity .sys-back-button img{
  padding: 8Px;
}

.plan-pay-check {
  width: 20Px;
  /*no*/
  height: 16Px;
  /*no*/
  background-position: -1270Px -205Px;
  /*no*/
}

.bottom-des-txt {
  line-height: 17Px;
}

.back-en {
  background: url('../../assets/images/workspace/SpecialOffer/label_SpecialOffer_en.png')
    no-repeat center center;
}

.back-de {
  background: url('../../assets/images/workspace/SpecialOffer/label_SpecialOffer_de.png')
    no-repeat center center;
}

.back-fr {
  background: url('../../assets/images/workspace/SpecialOffer/label_SpecialOffer_fr.png')
    no-repeat center center;
}

.back-por {
  background: url('../../assets/images/workspace/SpecialOffer/label_SpecialOffer_pt.png')
    no-repeat center center;
}

.back-spa {
  background: url('../../assets/images/workspace/SpecialOffer/label_SpecialOffer_es.png')
    no-repeat center center;
}

.back-it {
  background: url('../../assets/images/workspace/SpecialOffer/label_SpecialOffer_it.png')
    no-repeat center center;
}

.back-ja {
  background: url('../../assets/images/workspace/SpecialOffer/label_SpecialOffer_jp.png')
    no-repeat center center;
}

.back-tw {
  background: url('../../assets/images/workspace/SpecialOffer/label_SpecialOffer_tw.png')
    no-repeat center center;
}

.back-cn {
  background: url('../../assets/images/workspace/SpecialOffer/label_SpecialOffer_cn.png')
    no-repeat center center;
}

.plan-two-button .el-loading-spinner .circular {
  height: 0.25rem !important;
  width: 0.25rem !important;
  position: relative;
  top: 30Px;
}

.plan-two-button .el-loading-mask {
  background-color: #fc8123 !important;
  border-radius: 2Px;
  z-index: 10 !important;
}

.plan-two-button .el-loading-spinner .path {
  stroke: #ffffff !important;
}
.tips-txt{
 position: relative;
 float: left;
 text-align: center;
 width: 100%;
 font-size: 12Px;
 display: flex;
 align-items: center;
 justify-content: center;
 height: 50Px;
}

.pay-tip{
  font-size: 24Px;
  font-weight: 700;
  color: #1a1a1a;
}

.pay-tips {
  font-size: 14Px;
  color: #A3ADBD;
}

.pay-tips a{
  text-decoration: underline !important;
  color: #A3ADBD !important;
}

.paysys-cycle{
  top: 20Px;
  right: 23%;
  position: absolute;
  user-select: none;
}

.paysys-cycle .cycle-name,
.paysys-cycle .cycle-name-right{
  position: absolute;
  color: #a3adbd;
  float: left;
  font-size: 16Px;
  font-weight: 700;
  line-height: 24Px;
}

.paysys-cycle .cycle-name {
  white-space: nowrap;
  right: 58Px;
}

.paysys-cycle .cycle-name-right{
  text-align: left;
  left: 58Px;
}

.paysys-cycle .cycle-name-right .cycle-name-tips{
  font-size: 12Px;
  white-space: nowrap;
}

.paysys-cycle .check-cycle{
  color: #1a1a1a;
}

.christmas-title-img {
  width: fit-content;
  height: 190Px;
  margin: auto;
  /* background: url("../../assets/images/christmasSaled-2022/img_defray_decorate.png") no-repeat; */
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.paysys-countdown {
  text-align: center;
  height: 90Px;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/pay_system_activity.vue